import React from "react";

//Material Icons
import { Error } from "@mui/icons-material";

//UI Material
import { Box, Grid } from "@mui/material";

//Helpers
import {
  typographyForSubtitles,
  typographyForText,
} from "../Helpers/typography";

//Local components
import ContainedButton from "./basics/ContainedButton";

export default function ErrorBox() {
  return (
    <Box sx={{ flexGrow: 1 }} style={{ padding: "10%", marginBottom: "30px" }}>
      <Grid
        sx={{ flexGrow: 1, height: "100%" }}
        container
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid item xs={12} md={12}>
          <Error
            color="primary"
            sx={{
              fontSize: 150,
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          {typographyForSubtitles("Ha ocurrido un error")}
        </Grid>
        <Grid item xs={12} md={12}>
          {typographyForText("Por favor intente nuevamente")}
        </Grid>
        <Grid item sx={{ marginTop: "20px" }} xs={12} md={12}>
          <ContainedButton
            onClick={() => {
              window.location.reload();
            }}
            text="Reintentar"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
